import React from 'react';

import { Stack, Typography } from '@gogame/components';
import { useMonthFormat } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import { marketingPlanningPreviewLink } from 'scenes/MarketingPlanning/navigation';

const Final = ({ row }) => {
  const monthYearFormat = useMonthFormat();

  return (
    <Stack justifyContent={'center'} height={'100%'}>
      <Typography variant={'body2'}>
        {row?.final ? (
          <ScreenLink
            link={marketingPlanningPreviewLink}
            params={{
              year: row?.year,
              month: row?.month,
              version: row?.final?.version,
            }}
            style={{ textDecoration: 'underline' }}
            target={'_blank'}
          >
            {monthYearFormat({
              year: row?.year,
              month: row.month,
            })}
          </ScreenLink>
        ) : (
          monthYearFormat({ year: row?.year, month: row.month })
        )}
      </Typography>

      <Typography variant={'caption'} color={'textSecondary'}>
        {!row?.final?.viewVersion
          ? 'Not finalized yet'
          : `ver. ${row.final.viewVersion}`}
      </Typography>
    </Stack>
  );
};
export default Final;
